<style lang="stylus">
    .main-tool
        margin 16px 0px 0 0px
        // transform translateZ(0)
    .tool_box
        width 100%
        height 238px
        padding 16px
        border 1px solid var(--border-color-box-6)
        border-radius 6px

        .select_btn
            width 100%
            height 32px
            display flex
            position relative
            column-gap 8px
            z-index 8
            .btn_box
                width 62px
                height 32px
                border-radius 6px
                position relative
                transition all 0.1s linear
                text-align center

                .ivu-tooltip-rel
                    width 100%

                .ivu-tooltip-popper
                    .ivu-tooltip-content
                        .ivu-tooltip-inner
                            max-width none

                .img-content
                    display flex
                    align-items center
                    justify-content center
                    width 100%
                    height 32px
                    background transparent
                    user-select none

                    >svg
                        width 39px
                        height 12px
                        fill var(--svg-color-primary)
            .btn_box.active
                background-color var(--bg-color-float-tool-icon-active)

            .btn_box:hover
                background-color var(--bg-color-float-tool-icon-hover)

        .select_area
            position relative
            width 100%
            height 150px
            margin-top 24px
            overflow-x hidden
            overflow-y hidden

            .select_scrollarea
                position absolute
                left 0
                width 4500px
                height 150px

                .icon_box
                    float left
                    height 150px
                    padding 12px
                    border-radius 6px

                    ul
                        display flex
                        flex-wrap wrap
                        column-gap 2px
                        row-gap 2px
                        width 100%
                        height 126px

                        li
                            float left
                            width 30px
                            height 30px
                            border-radius 4px
                            background-color var(--bg-color-math-more-tab-li)
                            text-align center
                            line-height 30px
                            user-select none
                            display flex
                            align-items center
                            justify-content space-around

                            >img
                                user-select none
                                pointer-event none

                            &:hover
                                background-color var(--bg-color-math-more-tab-li-hover)

                .icon_box.active
                    background-color var(--bg-color-math-icon-box-active) !important

            .select_scrollcover
                position absolute
                left 0
                width 100%
                height 150px
                pointer-events none

    .floatFrame
        position fixed
        left 0
        top 300px
        z-index 1000
        width 575px
        height 350px
        padding 26px 0 4px 6px
        //background-color #cccdcf
        background var(--bg-color-tertiary)
        border-radius 5px
        box-shadow var(--box-math-more)
        overflow hidden
        font-family arial, '宋体', sans-serif

        .sa-close
            width 20px
            height 20px
            position absolute
            font-size 18px
            top 6px
            right 6px
            user-select none
            color #5b6274
            background var(--bg-color-tertiary)
            cursor pointer
            svg
                width 12px
                height 12px
                transition all 0.15s
                color var(--svg-color-primary)

            &:hover
                color #000

        .tabs-frame
            .ivu-tabs-bar
                margin-bottom 8px

            .tabs-content
                height 257px
                overflow auto

                ul
                    width 554px
                    height 553px
                    font-size 16px
                    border-radius 5px
                    padding 5px
                    background var(--bg-color-math-more-tab-ul)

                    li
                        float left
                        width 32px
                        height 32px
                        margin 1px
                        border-radius 2px
                        background-color var(--bg-color-math-more-tab-li)
                        text-align center
                        line-height 32px
                        user-select none
                        display flex
                        align-items center
                        justify-content space-around

                        &:hover
                            background-color var(--bg-color-math-more-tab-li-hover)
</style>
<i18n>
{
  "zh": {
    "tips": {
      "insertFail": "插入失败"
    },
    "matrixTitle": "请输入所需矩阵的行和列",
    "row": "行",
    "column": "列",
    "MathSymbol": "数学运算符",
    "AddedMathSymbol": "补充数学运算符",
    "ROSymbol": "关系与运算符符号",
    "ModSymbol": "修饰符",
    "ArrowSymbol": "箭头符号",
    "SundrySymbol": "杂项符号",
    "GreekSymbol": "希腊符号",
    "SeparatorTemp": "分隔符模板",
    "SRSTemp": "分数、根号和上下标模板",
    "SRCTemp": "求和，结果和集合模板",
    "IntegralTemp": "积分模板",
    "BTLTemp": "底线和顶线模板",
    "LabelArrowTemp": "标签的箭头模板",
    "RectTemp": "矩形模板",
    "more": "更多"
  },
  "jp": {
    "tips": {
      "insertFail": "挿入に失敗しました"
    },
    "matrixTitle": "必要な行列の行と列を入力してください",
    "row": "行",
    "column": "列",
    "MathSymbol": "数学演算子",
    "AddedMathSymbol": "数学演算子を追加",
    "ROSymbol": "関係と演算子",
    "ModSymbol": "修飾子",
    "ArrowSymbol": "矢印記号",
    "SundrySymbol": "その他の記号",
    "GreekSymbol": "ギリシャ文字",
    "SeparatorTemp": "区切り記号",
    "SRSTemp": "分数、根号、上付き/下付きの添字",
    "SRCTemp": "和、総和、集合",
    "IntegralTemp": "積分",
    "BTLTemp": "数式の上/下に線",
    "LabelArrowTemp": "ラベルの矢印",
    "RectTemp": "枠",
    "more": "もっと"
  },
  "en": {
    "tips": {
      "insertFail": "Fail to Insert"
    },
    "matrixTitle": "Please enter the rows and columns of the matrix.",
    "row": "Row",
    "column": "Column",
    "MathSymbol": "Mathematical Operator",
    "AddedMathSymbol": "Add Mathematical Operator",
    "ROSymbol": "Relation and Operation Symbol",
    "ModSymbol": "Modification Symbol",
    "ArrowSymbol": "Arrow Symbol",
    "SundrySymbol": "Sundry Symbol",
    "GreekSymbol": "Greek Symbol",
    "SeparatorTemp": "Separator Templates",
    "SRSTemp": "Score, Root Number and Superscript Template",
    "SRCTemp": "Summation, Result and Collection Template",
    "IntegralTemp": "Integral Template",
    "BTLTemp": "Bottom Line and Top Line Template",
    "LabelArrowTemp": "Label Arrow Template",
    "RectTemp": "Rectangle Templates",
    "more": "more"
  },
  "fr": {
    "tips": {
      "insertFail": "Échec d'insertion"
    },
    "matrixTitle": "Veuillez entrer les lignes et les colonnes de la matrice.",
    "row": "Ligne",
    "column": "Colonne",
    "MathSymbol": "Opérateur Mathématique",
    "AddedMathSymbol": "Ajouter un Opérateur Mathématique",
    "ROSymbol": "Symbole de Relation et de Fonctionnement",
    "ModSymbol": "Symbole de Modification",
    "ArrowSymbol": "Symbole de la Flèche",
    "SundrySymbol": "Symbole Divers",
    "GreekSymbol": "Symbole Grec",
    "SeparatorTemp": "Modèles de Séparateur",
    "SRSTemp": "Score, nombre racine et modèle en exposant",
    "SRCTemp": "Modèle de sommation, de résultat et de collecte",
    "IntegralTemp": "Modèle intégral",
    "BTLTemp": "Modèle de ligne inférieure et de ligne supérieure",
    "LabelArrowTemp": "Modèle de flèche d'étiquette",
    "RectTemp": "Modèles de rectangle",
    "more": "Plus"
  },
  "de": {
    "tips": {
      "insertFail": "Fehler beim Einfügen"
    },
    "matrixTitle": "Bitte geben Sie die Zeilen und Spalten der Matrix ein",
    "row": "Zeile",
    "column": "Spalte",
    "MathSymbol": "Mathematischer Operator",
    "AddedMathSymbol": "Mathematischen Operator hinzufügen",
    "ROSymbol": "Beziehungs- und Betriebssymbol",
    "ModSymbol": "Modifikations-Symbol",
    "ArrowSymbol": "Pfeilssymbol",
    "SundrySymbol": "Verschiedenes Symbol",
    "GreekSymbol": "Griechisches Symbol",
    "SeparatorTemp": "Teilungs-Vorlage",
    "SRSTemp": "Score, Root Number und hochgestellte Vorlage",
    "SRCTemp": "Summierungs-, Ergebnis- und Sammlungsvorlage",
    "IntegralTemp": "Integral-Vorlage",
    "BTLTemp": "Bottom Line und Top Line Vorlage",
    "LabelArrowTemp": "Beschriftungspfeilvorlage",
    "RectTemp": "Rechteckvorlagen",
    "more": "Mehr"
  },
  "es": {
    "tips": {
      "insertFail": "Fallar al insertar"
    },
    "matrixTitle": "Por favor, introduzca las filas y columnas de la matriz",
    "row": "Remar",
    "column": "Columna",
    "MathSymbol": "Operador matemático",
    "AddedMathSymbol": "Añadir Operador Matemático",
    "ROSymbol": "Símbolo de relación y operación",
    "ModSymbol": "Símbolo de modificación",
    "ArrowSymbol": "Símbolo de la flecha",
    "SundrySymbol": "Símbolo varios",
    "GreekSymbol": "Símbolo Griego",
    "SeparatorTemp": "Plantillas Separator",
    "SRSTemp": "Puntuación, número de raíz y plantilla de superíndice",
    "SRCTemp": "Plantilla de resumen, resultado y colección",
    "IntegralTemp": "Plantilla integral",
    "BTLTemp": "Plantilla de línea inferior y línea superior",
    "LabelArrowTemp": "Plantilla de la Flecha de la Etiqueta",
    "RectTemp": "Plantillas de Rectángulo",
    "more": "Más"
  },
  "pt": {
    "tips": {
      "insertFail": "Falha ao Inserir"
    },
    "matrixTitle": "Por favor, inserir as linhas e colunas da matriz.",
    "row": "Linha",
    "column": "Coluna",
    "MathSymbol": "Operador Matemático",
    "AddedMathSymbol": "Adicionar Operador Matemático",
    "ROSymbol": "Símbolo de Relação e Operação",
    "ModSymbol": "Símbolo de Modificação",
    "ArrowSymbol": "Símbolo Seta",
    "SundrySymbol": "Símbolo Diverso",
    "GreekSymbol": "Símbolo Grego",
    "SeparatorTemp": "Modelos de Separador",
    "SRSTemp": "Modelo de Pontuação, Número de Raíz e de Índice",
    "SRCTemp": "Modelo de Compactação, Resultado e Coleção",
    "IntegralTemp": "Modelo Integral",
    "BTLTemp": "Modelo de Linha Inferior e Linha Superior",
    "LabelArrowTemp": "Modelo de Seta de Etiqueta",
    "RectTemp": "Modelos de Rectângulo",
    "more": "Mais"
  },
  "it": {
    "tips": {
      "insertFail": "Inserimento Fallito"
    },
    "matrixTitle": "Si prega di inserire le righe e le colonne della matrice.",
    "row": "Riga",
    "column": "Colonna",
    "MathSymbol": "Operatore Matematico",
    "AddedMathSymbol": "Aggiungi Operatore Matematico",
    "ROSymbol": "Simbolo Relazione e Operazione",
    "ModSymbol": "Simbolo di Modifica",
    "ArrowSymbol": "Simbolo Freccia",
    "SundrySymbol": "Simbolo Vario",
    "GreekSymbol": "Simbolo Greco",
    "SeparatorTemp": "Modelli Separatore",
    "SRSTemp": "Modello Risultati, Radice e Apice",
    "SRCTemp": "Modello di Somma, Risultato e Raccolta",
    "IntegralTemp": "Modello Integrale",
    "BTLTemp": "Modello Linea Inferiore e Linea Superiore",
    "LabelArrowTemp": "Modello Etichetta Freccia",
    "RectTemp": "Modelli Rettangolo",
    "more": "Di Più"
  },
  "tw": {
    "tips": {
      "insertFail": "插入失敗"
    },
    "matrixTitle": "請輸入所需矩陣的行和列",
    "row": "行",
    "column": "列",
    "MathSymbol": "數學運算符",
    "AddedMathSymbol": "補充數學運算符",
    "ROSymbol": "關係與運算符符號",
    "ModSymbol": "修飾符",
    "ArrowSymbol": "箭頭符號",
    "SundrySymbol": "雜項符號",
    "GreekSymbol": "希臘符號",
    "SeparatorTemp": "分隔符模板",
    "SRSTemp": "分數、根號和上下標模板",
    "SRCTemp": "求和，結果和集合模板",
    "IntegralTemp": "積分模板",
    "BTLTemp": "底線和頂線模板",
    "LabelArrowTemp": "標籤的箭頭模板",
    "RectTemp": "矩形模板",
    "more": "更多"
  },
  "kr": {
    "tips": {
      "insertFail": "삽입 실패"
    },
    "matrixTitle": "행렬의 행과 열을 입력하십시오.",
    "row": "행",
    "column": "열",
    "MathSymbol": "수학 연산자",
    "AddedMathSymbol": "수학 연산자 추가",
    "ROSymbol": "관계와 연산자 심볼",
    "ModSymbol": "수정 심볼",
    "ArrowSymbol": "화살표 심볼",
    "SundrySymbol": "기타 심볼",
    "GreekSymbol": "그리스 심볼",
    "SeparatorTemp": "구분자 템플릿",
    "SRSTemp": "점수, 루트 번호 및 대문자 템플릿",
    "SRCTemp": "합계, 결과 및 수집 템플릿",
    "IntegralTemp": "통합 템플릿",
    "BTLTemp": "밑줄과 끝줄 템플릿",
    "LabelArrowTemp": "레이블 화살표 템플릿",
    "RectTemp": "직사각형 템플릿",
    "more": "더보기"
  }
}
</i18n>
<template>
    <div class="main-tool">
        <div class="tool_box" ref="toolBox">
            <div class="select_btn">
                <template v-for="(item, index) in btns">
                    <Tooltip
                        :content="$t(item.hint)"
                        placement="bottom-start"
                        class="btn_box"
                        :class="btnPreId == index + 1 ? 'active' : ''"
                        :key="item.id"
                    >
                        <div class="img-content" @click="selectBtnEvent(index + 1)">
                            <iconSymbol :name="item.img" />
                            <!-- <img :src='item.img'> -->
                        </div>
                    </Tooltip>
                </template>
            </div>
            <div class="select_area" ref="forScroll">
                <div class="select_scrollarea">
                    <template v-for="(item, index) in list">
                        <!-- 特殊的第一组 -->
                        <div
                            :id="item.id"
                            class="icon_box"
                            :key="item.id"
                            :style="`width: 662px; font-size: 16px; color: ${isDarkTheme() ? '#fff' : '#000'};`"
                            :class="btnPreId == index + 1 ? 'active' : ''"
                            v-if="index === 0"
                        >
                            <ul>
                                <li
                                    @mousedown="btnDown($event)"
                                    @mouseup="btnUp($event)"
                                    @mouseleave="btnUp($event)"
                                    v-for="(it, i) in firstArray"
                                    :key="it.id"
                                    @click="clickFirstSymbol(index, i)"
                                >
                                    {{ it }}
                                </li>
                                <!-- <li @click="clickFirstMore()" @mousedown="btnDown($event)" @mouseup="btnUp($event)" @mouseleave="btnUp($event)"><img :src="list[0].list[34]"></li> -->
                                <li
                                    @click="clickFirstMore($event)"
                                    ref="firstMore"
                                    @mousedown="btnDown($event)"
                                    @mouseup="btnUp($event)"
                                    @mouseleave="btnUp($event)"
                                >
                                    <div style="font-size: 12px; white-space: nowrap" :title="$t('more')">{{ $t("more") }}</div>
                                </li>
                            </ul>
                        </div>
                        <!-- 特殊的第一组 -->

                        <!-- 特殊的第四组 -->
                        <div
                            :id="item.id"
                            class="icon_box"
                            :key="item.id"
                            :style="`width: 342px; font-size: 16px; color: ${isDarkTheme() ? '#fff' : '#000'}`"
                            :class="btnPreId == index + 1 ? 'active' : ''"
                            v-if="index === 3"
                        >
                            <ul>
                                <li
                                    v-for="(it, i) in fourthArray"
                                    @mousedown="btnDown($event)"
                                    @mouseup="btnUp($event)"
                                    @mouseleave="btnUp($event)"
                                    :key="it.id"
                                    @click="clickFourthSymbol(index, i)"
                                >
                                    {{ it }}
                                </li>
                            </ul>
                        </div>
                        <!-- 特殊的第四组 -->

                        <div
                            :id="item.id"
                            class="icon_box"
                            :key="item.id"
                            :class="btnPreId == index + 1 ? 'active' : ''"
                            v-if="index > 0 && index != 3"
                        >
                            <ul>
                                <li
                                    v-for="(it, i) in item.list"
                                    @mousedown="btnDown($event)"
                                    @mouseup="btnUp($event)"
                                    @mouseleave="btnUp($event)"
                                    :key="it.id"
                                    @click="clickSymbol(index, i)"
                                >
                                    <div style="font-size: 12px; white-space: nowrap" v-if="it === 'more'" :title="$t('more')">{{ $t("more") }}</div>
                                    <img v-else :src="it" />
                                </li>
                            </ul>
                        </div>
                    </template>
                </div>
                <div class="select_scrollcover" id="scrollcover"></div>
            </div>
        </div>
        <editArea ref="areaRef"></editArea>
        <Modal v-model="modal1" @on-ok="ok" @on-cancel="cancel" width="290px">
            <p>{{ $t("matrixTitle") }}</p>
            <div class="rcArea">
                <span>{{ $t("row") }}:</span>
                <InputNumber :max="10" :min="1" v-model="row"></InputNumber>
            </div>
            <div class="rcArea">
                <span>{{ $t("column") }}:</span>
                <InputNumber :max="10" :min="1" v-model="col"></InputNumber>
            </div>
        </Modal>

        <!-- 数学运算符公式的弹出窗口 -->
        <div class="floatFrame" ref="floatFrame" style="display: none" v-show="isFloatShow">
            <div class="sa-close" @click="closeWin">
                <iconSymbol name="math-Del"></iconSymbol>
            </div>
            <div class="tabs-frame">
                <Tabs>
                    <TabPane :label="$t('MathSymbol')" :name="$t('MathSymbol')">
                        <div class="tabs-content">
                            <ul>
                                <li v-for="(item, index) in extendFormulaOne" :key="item.id" @click="clickExtendOne(index)">{{ item }}</li>
                            </ul>
                        </div>
                    </TabPane>
                    <TabPane :label="$t('AddedMathSymbol')" :name="$t('AddedMathSymbol')">
                        <div class="tabs-content">
                            <ul>
                                <li v-for="(item, index) in extendFormulaTwo" :key="item.id" @click="clickExtendTwo(index)">{{ item }}</li>
                            </ul>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </div>
        <!-- 数学运算符公式的弹出窗口 -->
        <!-- 箭头拓展公式的弹出窗口 -->
        <div class="floatFrame" ref="floatFrameTwo" style="display: none" v-show="isFloatShowTwo">
            <div class="sa-close" @click="closeWinTwo">
                <iconSymbol name="math-Del"></iconSymbol>
            </div>
            <div class="tabs-frame">
                <Tabs>
                    <TabPane :label="$t('ArrowSymbol')" :name="$t('ArrowSymbol')">
                        <div class="tabs-content">
                            <ul ref="arrowUl">
                                <li v-for="(item, index) in ExtendArrows" :key="item.id" @click="clickExtendArrow(index)">{{ item }}</li>
                            </ul>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </div>
        <!-- 拓展公式的弹出窗口 -->
    </div>
</template>

<script>
    import editArea from "./editArea.vue";
    import boxData from "../mixins/boxData";
    console.log(boxData);
    export default {
        name: "boxData",
        inject: ["EDMathUI"],
        mixins: [boxData],
        components: { editArea },
        data() {
            return {
                btns: [
                    {
                        hint: "ROSymbol",
                        img: "math-opGroup1",
                    },
                    {
                        hint: "ModSymbol",
                        img: "math-opGroup2",
                    },
                    {
                        hint: "ArrowSymbol",
                        img: "math-opGroup3",
                    },
                    {
                        hint: "SundrySymbol",
                        img: "math-opGroup4",
                    },
                    {
                        hint: "GreekSymbol",
                        img: "math-opGroup5",
                    },
                    {
                        hint: "SeparatorTemp",
                        img: "math-opGroup6",
                    },
                    {
                        hint: "SRSTemp",
                        img: "math-opGroup7",
                    },
                    {
                        hint: "SRCTemp",
                        img: "math-opGroup8",
                    },
                    {
                        hint: "IntegralTemp",
                        img: "math-opGroup9",
                    },
                    {
                        hint: "BTLTemp",
                        img: "math-opGroup10",
                    },
                    {
                        hint: "LabelArrowTemp",
                        img: "math-opGroup11",
                    },
                    {
                        hint: "RectTemp",
                        img: "math-opGroup12",
                    },
                ],
                btnPreId: 1,
                modal1: false,
                row: 1,
                col: 1,
                isFloatShow: false,
                isFloatShowTwo: false,
                everyArrScroll: [],
                extendFormulaOne: [],
                extendFormulaTwo: [],
                ExtendArrows: [],
                firstArray: [],
                fourthArray: [],
            };
        },
        methods: {
            //传入updateui函数进EdrawMath.EDFormulaView.creatEdFormulaview，每次编辑区进行操作时都能调用到updateui函数，从而更新派发顶部按钮状态
            updateui() {
                console.log(111);
                if (null != this.EDMathUI.view) {
                    var enble = [false, false, false, false];
                    var font = [false, false];
                    var coltype_1 = [0];
                    var fontSize = [40];
                    let color = [];
                    this.EDMathUI.view.getUiDate(enble, font, coltype_1, fontSize, color);
                    this.EDMathUI.uifontbold = font[0];
                    this.EDMathUI.uifontitalic = font[1];
                    // 派发按钮状态
                    this.$bus.$emit("mathColorStatus", color);
                    console.log(enble);
                    this.$bus.$emit("enbleSet", enble);
                    this.$bus.$emit("fontSet", font);
                    this.$bus.$emit("colSet", coltype_1);
                    this.$bus.$emit("fontSizeSet", fontSize);
                }
            },
            ok() {
                this.EDMathUI.view.insertMtable(this.row, this.col, this.EDMathUI.lineType, this.EDMathUI.arrType);
                this.row = 1;
                this.col = 1;
            },
            cancel() {
                this.row = 1;
                this.col = 1;
            },
            //按钮按下效果
            btnDown(e) {
                if (e.target.tagName == "IMG") {
                    e.target.parentElement.style.background = "#c0c0c0";
                } else {
                    e.target.style.background = "#c0c0c0";
                }
            },
            btnUp(e) {
                if (e.target.tagName == "IMG") {
                    e.target.parentElement.style.background = null;
                } else {
                    e.target.style.background = null;
                }
            },
            // 点击“数学运算符”拓展公式里的图标
            clickExtendOne(index) {
                index = index + 8704;
                this.EDMathUI.view.insertFormula(index);
            },
            // 点击“补充数学运算符”拓展公式里的图标
            clickExtendTwo(index) {
                index = index + 10752;
                this.EDMathUI.view.insertFormula(index);
            },
            // 点击“箭头运算符”拓展公式里的图标
            clickExtendArrow(index) {
                index = index + 8592;
                this.EDMathUI.view.insertFormula(index);
            },
            // 关闭第一个补充窗口
            closeWin() {
                this.isFloatShow = false;
                this.EDMathUI.view.focus();
            },
            // 关闭第二个补充窗口
            closeWinTwo() {
                this.isFloatShowTwo = false;
                this.EDMathUI.view.focus();
            },
            //各组滚动条距离设置
            selectBtnEvent(id) {
                console.log(id);
                this.btnPreId = id;
                let btnWidth = this.$refs.toolBox.offsetWidth / 16;
                let scrollcover = document.getElementById("scrollcover");
                if (id > 2) {
                    //先移到左下角位置对齐
                    let leftscroll = this.everyArrScroll[id - 1] - btnWidth * (id - 1);
                    //最后一组移右下角对齐
                    id === 12
                        ? (leftscroll += Math.ceil(this.arrayNum[id - 1] / 2) * 32 + 24 - 22)
                        : //其它的移到中间
                          (leftscroll += Math.ceil(this.arrayNum[id - 1] / 2) * 32 - parseInt(btnWidth / 2));
                    this.$refs.forScroll.scrollLeft = leftscroll;
                    scrollcover.style.left = leftscroll + "px";
                } else {
                    this.$refs.forScroll.scrollLeft = this.everyArrScroll[id - 1];

                    scrollcover.style.left = this.everyArrScroll[id - 1] + "px";
                }
            },
            // 给外层的li分别添加borderTop和borderLeft，还有设置每一组的宽度
            initBoxWidth(b, l, index) {
                let c = document.getElementById(b);
                let num = this.arrayNum[index];
                // for (let i = 0; i < num; i++) {
                //     c.children[0].children[i].style.borderTop = "1px solid #8c8b8d";
                // }
                // c.children[0].children[0].style.borderLeft = "1px solid #8c8b8d";
                // c.children[0].children[num].style.borderLeft = "1px solid #8c8b8d";
                // c.children[0].children[2 * num].style.borderLeft =
                //     "1px solid #8c8b8d";
                // c.children[0].children[3 * num].style.borderLeft =
                //     "1px solid #8c8b8d";
                c.style.width = num * 32 - 2 + 24 + "px";
            },
            // 点击第一组图标
            clickFirstSymbol(e1, e2) {
                this.EDMathUI.view.insertFormula(this.firstList[e2]);
            },
            // 点击第四组图标
            clickFourthSymbol(e1, e2) {
                this.EDMathUI.view.insertFormula(this.fourthList[e2]);
            },
            // 弹出第一个补充窗口
            clickFirstMore(event) {
                if (this.isFloatShow === true) {
                    this.isFloatShow = false;
                } else {
                    console.log(event);
                    this.$nextTick(() => {
                        let curEle = this.$refs.firstMore[0];
                        let floatFrame = this.$refs.floatFrame;

                        let rect = curEle.getBoundingClientRect();
                        floatFrame.style.left = `${rect.left}px`;
                        floatFrame.style.top = `${rect.top + rect.height + 6}px`;
                    });
                    this.isFloatShow = true;
                }
                this.EDMathUI.view.focus();
            },
            // 点击图标
            clickSymbol(e1, e2) {
                if (e1 == 11) {
                    if (e2 == 13) {
                        this.modal1 = true;
                    } else {
                        if (e2 === 0 || e2 === 4 || e2 === 8 || e2 === 12) {
                            let getE = parseInt(e2 / 4);
                            let isSuccess = this.EDMathUI.view.insertFormula(this.EDBtnDataArray[e1][getE]);
                            isSuccess == false ? this.$root.ui.showMsgBox(this.$t("tips.insertFail")) : "";
                        } else {
                            this.EDMathUI.view.insertMtable(
                                this.EDMtableArray[e2][0],
                                this.EDMtableArray[e2][1],
                                this.EDMathUI.lineType,
                                this.EDMathUI.arrType
                            );
                        }
                    }
                } else {
                    if (e1 === 2 && e2 === 26) {
                        if (this.isFloatShowTwo === true) {
                            this.isFloatShowTwo = false;
                        } else {
                            let floatFrameTwo = this.$refs.floatFrameTwo;
                            floatFrameTwo.style.left = event.clientX + 1 + "px";
                            floatFrameTwo.style.top = event.clientY + 1 + "px";
                            this.isFloatShowTwo = true;
                        }
                        this.EDMathUI.view.focus();
                    } else {
                        let isSuccess = this.EDMathUI.view.insertFormula(this.EDBtnDataArray[e1][e2]);
                        isSuccess == false ? this.$root.ui.showMsgBox(this.$t("tips.insertFail")) : "";
                    }
                }
            },
        },
        mounted() {
            //初始化编辑区
            let edrawMath = this.$refs.areaRef.$el;
            let edimage = this.$store.state.shape.edimage;
            this.EDMathUI.view = EDFormulaView4Max.creatEdFormulaview(edrawMath, this.updateui, edimage);
            if (edimage) this.EDMathUI.view.openMml(edimage.outputMml());
            this.$store.commit("setShapeStatus", { type: "edimage", data: null });
            this.EDMathUI.view.setSize(100, 100);
            console.log("math ui inited");

            let con = this.$refs.toolBox;
            //IE和谷歌滚动行为
            con.addEventListener(
                "mousewheel",
                (event) => {
                    event.preventDefault();
                    if (event.deltaY > 0 && this.btnPreId < 12) this.btnPreId++;
                    if (event.deltaY < 0 && this.btnPreId > 1) this.btnPreId--;
                    this.selectBtnEvent(this.btnPreId);
                },
                false
            );
            //Firefox滚动行为
            con.addEventListener(
                "DOMMouseScroll",
                (event) => {
                    event.preventDefault();
                    if (event.detail > 0 && this.btnPreId < 12) this.btnPreId++;
                    if (event.detail < 0 && this.btnPreId > 1) this.btnPreId--;
                    this.selectBtnEvent(this.btnPreId);
                },
                false
            );
            // 给除了第一组之外的其他组添加最外层的上左边框
            for (let i = 1; i < this.list.length; i++) {
                if (i == 3) {
                    continue;
                }
                let box = "box" + (i + 1);
                this.initBoxWidth(box, this.list[i].list, i);
            }

            /* 弹出框拖动相关js代码 */
            var Dragging = function (validateHandler) {
                //参数为验证点击区域是否为可移动区域，如果是返回欲移动元素，负责返回null
                var draggingObj = null; //dragging Dialog
                var diffX = 0;
                var diffY = 0;

                function mouseHandler(e) {
                    switch (e.type) {
                        case "mousedown":
                            draggingObj = validateHandler(e); //验证是否为可点击移动区域
                            if (draggingObj != null) {
                                diffX = e.clientX - draggingObj.offsetLeft;
                                diffY = e.clientY - draggingObj.offsetTop;
                            }
                            break;

                        case "mousemove":
                            if (draggingObj) {
                                draggingObj.style.left = e.clientX - diffX + "px";
                                draggingObj.style.top = e.clientY - diffY + "px";
                            }
                            break;

                        case "mouseup":
                            draggingObj = null;
                            diffX = 0;
                            diffY = 0;
                            break;
                    }
                }

                return {
                    enable: function () {
                        document.addEventListener("mousedown", mouseHandler);
                        document.addEventListener("mousemove", mouseHandler);
                        document.addEventListener("mouseup", mouseHandler);
                    },
                    disable: function () {
                        document.removeEventListener("mousedown", mouseHandler);
                        document.removeEventListener("mousemove", mouseHandler);
                        document.removeEventListener("mouseup", mouseHandler);
                    },
                };
            };

            function getDraggingDialog(e) {
                // e.stopPropagation();

                var target = e.target;

                if (target.className === "floatFrame") {
                    return target;
                } else {
                    return null;
                }
            }
            Dragging(getDraggingDialog).enable();
            /* 弹出框拖动相关js代码 */

            // 获取每组滚动到最前的滚动值
            let currentNum = 0;
            for (let i = 0; i < this.list.length; i++) {
                this.everyArrScroll[i] = currentNum;
                currentNum += 30 * this.arrayNum[i] + 2 * (this.arrayNum[i] - 1) + 24;
            }

            // 获取拓展区“数学运算符”数组
            for (let i = 0; i < 256; i++) {
                let newI = i + 8704;
                newI = String.fromCharCode(newI);
                this.extendFormulaOne.push(newI);
            }
            // 获取拓展区“补充数学运算符”数组
            for (let i = 0; i < 256; i++) {
                let newI = i + 10752;
                newI = String.fromCharCode(newI);
                this.extendFormulaTwo.push(newI);
            }
            //获取拓展区“箭头运算符”数组
            for (let i = 0; i < 112; i++) {
                let newI = i + 8592;
                newI = String.fromCharCode(newI);
                this.ExtendArrows.push(newI);
            }
            // 设置第二个弹窗的高度为了改变左边框的长度
            this.$refs.arrowUl.style.height = "248px";
            // 获取第一组图标的文本
            for (let i = 0; i < this.firstList.length; i++) {
                let newI = String.fromCharCode(this.firstList[i]);
                this.firstArray.push(newI);
            }
            // 获取第四组图标的文本
            for (let i = 0; i < this.fourthList.length; i++) {
                let newI = String.fromCharCode(this.fourthList[i]);
                this.fourthArray.push(newI);
            }
        },
    };
</script>
